import { connect } from 'react-redux';
import { isLogin, isLoading, myUsername, myLoginType, myProfile } from './selectors';

export const withLoginStatus = connect((state) => ({
  isLoading: isLoading(state),
  isLogin: isLogin(state),
}));
export const withUsername = connect((state) => ({ username: myUsername(state) }));
export const withLoginType = connect((state) => ({ loginType: myLoginType(state) }));
export const withUserProfile = connect((state) => ({ userProfile: myProfile(state) }));

export default { withLoginStatus, withUsername, withLoginType, withUserProfile };
